import type { SignatureV2Action, SignatureV2Step, SignatureV2Workflow } from '@/types/signatureV2';

export const hasSignatureV2Action = (
  availableActions: readonly SignatureV2Action[] | undefined,
  action: SignatureV2Action
): boolean => Boolean(availableActions?.includes(action));

export const canUseSignatureV2StepAction = (
  workflow: { available_actions?: readonly SignatureV2Action[]; current_step: { id: number } | null },
  step: Pick<SignatureV2Step, 'id' | 'status'> | undefined,
  action: 'open_signing_entry' | 'resend_current_invitation'
): boolean =>
  Boolean(
    step &&
      step.status === 'actionable' &&
      workflow.current_step?.id === step.id &&
      hasSignatureV2Action(workflow.available_actions, action)
  );

const cancellationLockedStatuses = new Set([
  'cancelling',
  'terminating',
  'reconciliation_required',
  'completed',
  'cancelled',
  'failed',
]);

export const canCancelSignatureV2Workflow = (
  workflow: Pick<SignatureV2Workflow, 'status' | 'cancel_requested_at' | 'available_actions'>
): boolean =>
  Boolean(
    !workflow.cancel_requested_at &&
      !cancellationLockedStatuses.has(workflow.status) &&
      hasSignatureV2Action(workflow.available_actions, 'cancel')
  );
